module.exports = __webpack_public_path__ + "static/Insects-a92af64d745724ca7bff8ae105878bc1.gif";